import { TChannel } from "types/channel";
import { handleObjectMessages } from "helpers/handleObjectMessages";
import { groupChannelHistory, groupChannelList } from "services/manageFamilies";

export const getChannelsWithReports = async (familyId: string) => {
  try {
    const { data } = await groupChannelList(familyId);

    const promises = data.map(async (channel: TChannel) => {
      const { data: infoChannel } = await groupChannelHistory(
        familyId,
        channel.id
      );
      const messagesFormatted = handleObjectMessages(infoChannel);
      const hasReports =
        messagesFormatted.filter((message: any) => message.flaggedMessages)
          .length > 0;

      return {
        ...channel,
        hasReports,
      };
    });

    const infoChannel: any = await Promise.all(promises);

    return infoChannel;
  } catch (err: any) {
    console.error(err);
    return [];
  }
};
